export default __webpack_public_path__ + "static/bg_laptop-41ce3c55173d07195598e9b86e6d8f92.jpg";